import TreeSelect from './tree-select.vue';
export default TreeSelect;


// WEBPACK FOOTER //
// ./src/components/tree-select/index.js